import React from 'react';
import {
  List, Loader, Button, Message,
} from 'semantic-ui-react';
import { bool, shape, func } from 'prop-types';

const SearchResults = ({ loadingSearchResults, searchResults, updateBook }) => (
  <>
    {searchResults.data && (
      <List relaxed divided>
        {searchResults.data.verses.map(verse => (
          <List.Item key={verse.id}>
            <List.Content floated="right">
              <Button
                icon="book"
                content="View Chapter"
                onClick={() => updateBook(verse.bookId, verse.chapterId)}
              />
            </List.Content>
            <List.Content>
              <List.Header>{verse.reference}</List.Header>
              <List.Description>{verse.text}</List.Description>
            </List.Content>
          </List.Item>
        ))}
        {searchResults.data.verses.length === 0 && (
          <Message>No results found</Message>
        )}
      </List>
    )}
    {loadingSearchResults && <Loader active />}
  </>
);

SearchResults.propTypes = {
  loadingSearchResults: bool.isRequired,
  searchResults: shape().isRequired,
  updateBook: func.isRequired,
};

export default SearchResults;
